import { render, staticRenderFns } from "./TraxUiAjaxTableWithCrudActions.vue?vue&type=template&id=a0e56728"
import script from "./TraxUiAjaxTableWithCrudActions.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxTableWithCrudActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports